<div
    class="lyrics-modal relative bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900
    rounded-2xl shadow-2xl overflow-hidden max-w-4xl w-full mx-auto">
  <!-- Close Button -->
  <button
      (click)="hideModal()"
      class="absolute top-4 right-4 z-10 text-gray-400 bg-white/80 dark:bg-gray-700/80 backdrop-blur-sm hover:bg-white dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white
       rounded-full text-sm w-10 h-10 inline-flex justify-center items-center transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-110"
      type="button">
    <svg aria-hidden="true" class="w-4 h-4" fill="none" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
      <path d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" stroke="currentColor" stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"/>
    </svg>
    <span class="sr-only">Close modal</span>
  </button>

  <!-- Header Section -->
  <div
      class="lyrics-header relative p-8 pb-6 bg-gradient-to-r from-mypart_red/10 via-purple-500/10 to-blue-500/10 dark:from-mypart_red/20 dark:via-purple-500/20 dark:to-blue-500/20 border-b border-gray-200 dark:border-gray-700">
    <div class="text-center space-y-2">
      <h1 class="text-3xl md:text-4xl font-bold leading-tight tracking-tight text-gray-900 dark:text-white">
        {{ title }}
      </h1>
      <h2 class="text-xl md:text-2xl font-medium text-gray-600 dark:text-gray-300">
        {{ artist }}
      </h2>
      <div class="flex justify-center items-center gap-2 pt-2">
        <div class="h-1 w-16 bg-gradient-to-r from-mypart_red to-purple-500 rounded-full"></div>
        <svg class="w-5 h-5 text-mypart_red" fill="currentColor" viewBox="0 0 20 20">
          <path
              d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z"/>
        </svg>
        <div class="h-1 w-16 bg-gradient-to-l from-mypart_red to-purple-500 rounded-full"></div>
      </div>
    </div>
  </div>

  <!-- Scrollable Lyrics Content -->
  <div #lyricsWrapper class="lyrics-content-wrapper relative is-scrolled-top">
    <div #lyricsContent class="lyrics-content p-8 md:p-12 max-h-[60vh] overflow-y-auto">
      <div class="lyrics-text whitespace-pre-line text-gray-700 dark:text-gray-300 text-lg leading-relaxed">
        {{ lyrics }}
      </div>
    </div>

    <!-- Scroll fade indicators -->
    <div
        class="scroll-fade-top absolute top-0 left-0 right-0 h-8 bg-gradient-to-b from-gray-50 dark:from-gray-900 to-transparent pointer-events-none opacity-0 transition-opacity"></div>
    <div
        class="scroll-fade-bottom absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-gray-50 dark:from-gray-900 to-transparent pointer-events-none opacity-0 transition-opacity"></div>
  </div>
</div>
